import axios from "axios";
import Config from "../../../config";
import { handleApiError, handleAxiosError } from "../../utils/errorHandler";
import {
  callNotification,
  clearHighChartopData,
  deepCopy,
  errorCode,
  getBrands,
  getCustomizedDate,
  getDefaultDuration,
  getFormattedBrandsForApi,
  getSelectedCompBrand,
  getTemporaryWords,
  getUTCOffset,
  getWindowLocationPath,
  sessionExpired,
} from "../../constants";
import {
  setBrandsInScreen,
  setCampaignProfileList,
  setCampaignQuickProfile,
  setClearScreenWidgetGraphData,
  setCountryStateCityData,
  setCountryStateCityLoader,
  setDateAggregationLoader,
  setDurationInScreen,
  setGlobalFiltersInScreen,
  setMarkInfluencersFlag,
  setMarkInfluencersList,
  setOpenCampaignPopup,
  setScreenDeepDiveData,
  setScreenLoader,
  setScreenUpdatedData,
  setScreenWidgetMetaData,
  setScreenWidgetResponseGraphData,
  setSearchedTopicList,
  setSearchedTopicLoader,
  setStreamScreenDefaultWidget,
  updateScreenApiCalledList,
  updateScreenWidgetPropdataWithClearGraphData,
} from "./screens/screen";
import {
  getGlobalScreenBrandsValue,
  getUpdatedScreenWidgetListBasedOnCompetitorCheck,
  getWidgetIdForScreenApiCalledList,
} from "../../constants/commandCenterConstants";
import { setOptionHighChart } from "../HighChart";
import { setErrorCode } from "../Workspace";
import { getDeepDive, setDeepDiveLoader } from "../WidgetMaker/WidgetAPI";
import {
  setDeepDiveInfoLoader,
  setMentionPageData,
  setMentionPageInnerTabs,
  setMentionTabsNews,
} from "../DeepDive";
import uuid from "react-uuid";
import { setGraphLoader, setProfileLoader } from "../ApiCall";
import moment from "moment";
import {
  setChannelImage,
  setProfileImage,
  setSelectProfileId,
} from "../Template";
import { setDeepDiveObject } from "../WidgetMaker/WidgetMaker";
import { getBrandHiddenWords, setBrandValue } from "../ApiCall/apiCall";
import { screensWithPersistedFilters } from "../../constants/enums";
import { setSelectedThemeState } from "../DIYPersonalization/PersonalizationSettings";
import { applyThemeWithVariable } from "../../../features/DIYPersonalization/PersonalizationPreview/PersonalizationMapping";
import { setThemeId } from "../AuthParams";

//api call to set country ,state , and city list
export const getCountryStateCity = (authParams, countryCode) => {
  return async (dispatch) => {
    dispatch(setCountryStateCityLoader(true));
    let body = {
      ptoken: authParams?.ptoken ? authParams?.ptoken : undefined,
      user_id: authParams?.userid,
      country_code: countryCode ? countryCode : "",
      utcoffset: getUTCOffset(),
    };
    let url = `${Config?.config1?.api_link}/command-center/get-state-city-for-twitter-trend`;
    axios
      .post(url, body)
      .then((response) => {
        dispatch(setCountryStateCityLoader(false));
        if (response?.status === "successful" || response?.status === 200) {
          let StateCityData = response?.data?.result
            ? response?.data?.result
            : response?.data;
          if (StateCityData && Array.isArray(StateCityData)) {
            const uniqueStateCityData = Array.from(
              new Set(
                StateCityData?.filter(
                  (item) => item?.country && item?.countrycode
                )
              )
            );
            dispatch(setCountryStateCityData(uniqueStateCityData));
          }
        }
        if (response?.data?.status === "error") {
          dispatch(setCountryStateCityData(null));
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

//api call to set brand based profiles
export const setScreenProfileList = (
  authParams,
  screenfetchRes,
  screenObject,
  type,
  section_id
) => {
  return async (dispatch) => {
    dispatch(setProfileLoader(true));
    dispatch(setSelectProfileId(null));
    dispatch(setChannelImage(null));
    dispatch(setProfileImage(null));
    dispatch(setCampaignProfileList(null));
    dispatch(setCampaignQuickProfile(null));
    let defaultDuration = getDefaultDuration({
      isCommandCenter: true,
    });

    let brands = screenfetchRes?.brands?.columns
      ? screenfetchRes?.brands?.columns
      : screenfetchRes?.brands
      ? screenfetchRes?.brands
      : screenObject?.global_dashboard_brands?.columns
      ? screenObject?.global_dashboard_brands?.columns
      : screenObject?.global_dashboard_brands
      ? screenObject?.global_dashboard_brands
      : screenObject?.singleBrands;
    let brand_obj = getFormattedBrandsForApi(
      screenfetchRes?.isBrandModified,
      brands
    );

    if (authParams) {
      let body = {
        ptoken: authParams?.ptoken,
        start_date: screenfetchRes?.start_date
          ? screenfetchRes?.start_date
          : screenObject?.global_dashboard_duration?.from
          ? screenObject?.global_dashboard_duration?.from
          : defaultDuration?.from,
        end_date: screenfetchRes?.end_date
          ? screenfetchRes?.end_date
          : screenObject?.global_dashboard_duration?.to
          ? screenObject?.global_dashboard_duration?.to
          : defaultDuration?.to,
        brand_list:
          brand_obj?.single_brands && brand_obj?.single_brands?.[0]?.brand_id
            ? brand_obj?.single_brands
            : null,
        brand_groups:
          brand_obj?.brandsGroupName?.length > 0
            ? brand_obj?.brandsGroupName
            : null,
        filters: [],
        hidden_filter: screenfetchRes?.hidden_filter,
        quick_filter_key: screenfetchRes?.quick_filter,
        utcoffset: getUTCOffset(),
      };
      let url = `${Config.config1.api_link}/template/search-quick-filter`;

      await axios
        .post(url, body)
        .then((response) => {
          dispatch(setCampaignProfileList(response?.data?.result));
          if (response?.data?.status === "successful") {
            //campaign dashboard through url
            let quickFilterIndex = response?.data?.result?.findIndex(
              (el) => el?.id?.toString() === authParams?.quickFilterValue
            );
            let quickFilterMetaData =
              quickFilterIndex >= 0
                ? response?.data?.result?.[quickFilterIndex]
                : null;
            let screenData = { ...screenfetchRes };
            dispatch(
              setSelectProfileId(
                quickFilterMetaData?.name
                  ? quickFilterMetaData?.name
                  : response?.data?.result
                  ? response?.data?.result?.[0]?.name
                  : ""
              )
            );
            dispatch(
              setProfileImage(
                quickFilterMetaData?.profile_icon_url
                  ? quickFilterMetaData?.profile_icon_url
                  : response?.data?.result
                  ? response?.data?.result?.[0]?.profile_icon_url
                  : ""
              )
            );

            dispatch(
              setChannelImage(
                screenData.hidden_filter && response?.data?.result
                  ? response?.data?.result?.[0]?.channel
                  : null
              )
            );

            if (screenData?.quick_filter === "CampaignID") {
              let start_date = quickFilterMetaData?.start_date
                ? moment(quickFilterMetaData?.start_date)
                : response?.data?.result &&
                  moment(response?.data?.result?.[0]?.start_date);
              let end_date = quickFilterMetaData?.end_date
                ? moment(quickFilterMetaData?.end_date)
                : response?.data?.result &&
                  moment(response?.data?.result?.[0]?.end_date);
              let dateDiff;

              if (
                (response?.data?.result?.[0]?.start_date &&
                  response?.data?.result?.[0]?.end_date) ||
                (quickFilterMetaData?.start_date &&
                  quickFilterMetaData?.end_date)
              ) {
                dateDiff = end_date.diff(start_date, "days") + 1;
              }
              let final_end_date;
              let currentEndDate = moment(new Date()).format("YYYY/MM/DD H:mm");
              if (
                response?.data?.result?.[0]?.start_date < currentEndDate &&
                response?.data?.result?.[0]?.end_date > currentEndDate
              ) {
                final_end_date = currentEndDate;
              }

              // get date difference for which end date is greater than current date
              let final_date_diff;
              if (start_date && final_end_date) {
                final_date_diff =
                  moment(final_end_date).diff(start_date, "days") + 1;
              }

              // if condition to get start_date in case of final_end_date
              let final_start_date;
              if (
                final_date_diff < 7 &&
                response?.data?.result?.[0]?.end_date > currentEndDate
              ) {
                final_start_date = moment(
                  response?.data?.result?.[0]?.start_date
                ).format("YYYY/MM/DD H:mm");
              } else if (
                final_date_diff > 7 &&
                response?.data?.result?.[0]?.end_date > currentEndDate
              ) {
                final_start_date = moment(final_end_date)
                  .subtract(6, "d")
                  .set({ hour: "00", minute: "00" })
                  .format("YYYY/MM/DD HH:mm");
              } else if (
                dateDiff > 7 &&
                response?.data?.result?.[0]?.end_date < currentEndDate
              ) {
                //check if diff is more than 7, then make the selected date 7 days, i.e end date -7
                final_start_date = quickFilterMetaData?.end_date
                  ? moment(quickFilterMetaData?.end_date)
                      .subtract(6, "d")
                      .set({ hour: "00", minute: "00" })
                      .format("YYYY/MM/DD HH:mm")
                  : moment(response?.data?.result?.[0]?.end_date)
                      .subtract(6, "d")
                      .set({ hour: "00", minute: "00" })
                      .format("YYYY/MM/DD HH:mm");
              }

              let diffDuration = {
                from: final_start_date
                  ? final_start_date
                  : quickFilterMetaData?.start_date
                  ? quickFilterMetaData?.start_date
                  : response?.data?.result &&
                    response?.data?.result?.[0]?.start_date,
                to: final_end_date
                  ? final_end_date
                  : quickFilterMetaData?.end_date
                  ? quickFilterMetaData?.end_date
                  : response?.data?.result &&
                    response?.data?.result?.[0]?.end_date,
              };

              let duration = {
                from: quickFilterMetaData?.start_date
                  ? quickFilterMetaData?.start_date
                  : response?.data?.result &&
                    response?.data?.result?.[0]?.start_date
                  ? response?.data?.result?.[0]?.start_date
                  : moment(
                      moment()?.subtract(6, "days")?.format("YYYY-MM-DD") +
                        " 00:00"
                    )?.format("YYYY/MM/DD HH:mm"),
                to: quickFilterMetaData?.end_date
                  ? quickFilterMetaData?.end_date
                  : final_end_date
                  ? final_end_date
                  : response?.data?.result &&
                    response?.data?.result?.[0]?.end_date
                  ? response?.data?.result?.[0]?.end_date
                  : moment(new Date()).format("YYYY/MM/DD HH:mm"),
              };
              let quick_filter = authParams?.quickFilterValue
                ? {
                    attribute:
                      screenfetchRes.quick_filter === "AccountID"
                        ? "SettingID"
                        : screenfetchRes?.quick_filter === "Category"
                        ? "CategoryID"
                        : screenfetchRes.quick_filter,
                    type: "varchar",
                    columns: [
                      {
                        name: authParams?.quickFilterValue?.toString(),
                        type: "include",
                      },
                    ],
                    name: quickFilterMetaData?.name,
                    profile_icon_url: quickFilterMetaData?.profile_icon_url,
                    channel: quickFilterMetaData?.channel,
                    duration: duration,
                  }
                : response?.data?.result?.[0]?.id
                ? {
                    attribute:
                      screenfetchRes.quick_filter === "AccountID"
                        ? "SettingID"
                        : screenfetchRes?.quick_filter === "Category"
                        ? "CategoryID"
                        : screenfetchRes.quick_filter,
                    type: "varchar",
                    columns: [
                      {
                        name:
                          screenfetchRes?.quick_filter === "Category"
                            ? (response?.data?.result?.[0]?.id).toString()
                            : (response?.data?.result?.[0]?.id).toString(),
                        type: "include",
                        display_name: response?.data?.result?.[0]?.name,
                      },
                    ],
                    name: response?.data?.result?.[0]?.name,
                    profile_icon_url:
                      response?.data?.result?.[0]?.profile_icon_url,
                    channel: response?.data?.result?.[0]?.channel,
                    duration: duration,
                  }
                : null;
              dispatch(setCampaignQuickProfile(quick_filter));
            }

            // ends here

            // remove other widget which is not required in this screen
            if (type === "global_brands") {
            } else {
              if (
                screenData?.widgets?.length > 0 &&
                Array.isArray(screenData?.widgets)
              ) {
                let updatedScreenWidgets = [];
                screenData?.widgets?.forEach((el) => {
                  if (
                    screenObject?.includedWidgetList?.includes(el?.widget_id)
                  ) {
                    updatedScreenWidgets?.push({ ...el });
                  }
                });
                screenData = {
                  ...screenData,
                  widgets:
                    updatedScreenWidgets?.length > 0
                      ? updatedScreenWidgets
                      : screenData?.widgets,
                };
              }
              dispatch(setScreenUpdatedData(screenData));
            }
          }
          if (response?.data?.status === "error") {
            handleApiError(response, dispatch);
          }
          dispatch(setProfileLoader(false));
        })
        .catch((error) => {
          handleAxiosError(error, dispatch);
          dispatch(setProfileLoader(false));
          dispatch(setCampaignProfileList(null));
        });
    } else {
      dispatch(setCampaignProfileList(null));
    }
  };
};

// to save settings
export const fetchScreenData = (
  authParams,
  stateContainer,
  selectedThemeId
) => {
  return async (dispatch) => {
    dispatch(setScreenLoader(true));
    let body = {
      ptoken: authParams?.ptoken,
      screen_id: authParams?.screen_id,
      is_preview:
        window.location.pathname?.toLowerCase() ===
        "/commandcenter/screens/personalize"
          ? true
          : false, // to get dummydata
      utcoffset: getUTCOffset(),
    };
    let url = `${Config.config1.api_link}/command-center/screen-fetch`;
    await axios
      .post(url, body)
      .then((response) => {
        if (response?.status === 200) {
          dispatch(setScreenLoader(false));
          if (response?.data?.status === "successful") {
            let screenFetchResData = { ...response?.data?.result };
            // to use as dummy data for other tagcloud widgets for share of voice screen
            let dummyWidgetGraphData;
            if (authParams?.screen_id === "000-000-558") {
              dummyWidgetGraphData = [
                ...screenFetchResData?.widgets?.filter(
                  (wid) => wid.widget_name === "TagCloud"
                ),
              ]?.[0]?.graphData;
            } else if (authParams?.screen_id === "000-000-557") {
              dummyWidgetGraphData = [...screenFetchResData?.widgets]?.[0]
                ?.graphData;
            }
            let includedWidgetList = [];
            let screenBrand = null;
            let screenDuration = null;
            let screenFilter = null;
            let screenObject = {
              singleBrands: stateContainer?.singleBrands,
            };
            let defaultSingleBrand = getBrands(
              stateContainer?.logicalBrands,
              [stateContainer?.singleBrands?.[0]],
              stateContainer?.singleBrands,
              null
            );
            let defaultDuration = getDefaultDuration({
              isCommandCenter: true,
            });
            // console.log("defaultSingleBrand", defaultSingleBrand);

            let topFiveBrandList = [];
            if (authParams?.screen_id === "000-000-557") {
              let singleBrands = stateContainer?.singleBrands;
              singleBrands?.map((o, i) => {
                if (i < 5) {
                  topFiveBrandList = [
                    ...topFiveBrandList,
                    {
                      group: false,
                      name: o?.brand_id,
                      type: "include",
                      brand_friendly_name: o?.brand_friendly_name,
                      competitor: o?.competitor,
                      competitorList: o?.competitorList,
                      brand_name: o?.brand_name,
                      brand_logo: o?.brand_logo,
                      brand_id: o?.brand_id,
                    },
                  ];
                }
              });
            } else if (authParams?.screen_id === "000-000-500") {
              if (authParams?.filterScreen) {
                screenBrand = authParams?.brandId
                  ? authParams?.brandId
                  : authParams?.brandGroup
                  ? authParams?.brandGroup
                  : authParams?.compBrands
                  ? authParams?.compBrands
                  : null;

                screenDuration = {
                  from: authParams?.start_date,
                  to: authParams?.end_date,
                };
                includedWidgetList = ["000-100-900", "000-100-907"];
              } else {
                includedWidgetList = [
                  "000-100-900",
                  "000-100-901",
                  "000-100-902",
                  "000-100-903",
                  "000-100-904",
                  "000-100-905",
                  "000-100-906",
                ];
              }
            } else if (authParams?.screen_id === "000-000-558") {
              let singleBrands = stateContainer?.singleBrands?.length
                ? deepCopy(stateContainer?.singleBrands)
                : [];
              let compBrandList = singleBrands?.splice(0, 4);
              let selectedNormalBrand = getBrands(
                stateContainer?.logicalBrands,
                compBrandList,
                stateContainer?.singleBrands,
                null
              );
              screenBrand = selectedNormalBrand;
            } else if (
              [
                "000-000-566", // for google screen
              ]?.includes(authParams?.screen_id)
            ) {
              let twoDaysDuration = getCustomizedDate(1, "Days");
              screenDuration = {
                from:
                  moment(twoDaysDuration?.date?.[0]).format("YYYY/MM/DD") +
                  " " +
                  twoDaysDuration?.time?.startTime,
                to:
                  moment(twoDaysDuration?.date?.[1]).format("YYYY/MM/DD") +
                  " " +
                  twoDaysDuration?.time?.endTime,
              };
            } else if (authParams?.filterScreen) {
              screenBrand = authParams?.brandId
                ? authParams?.brandId
                : authParams?.brandGroup
                ? authParams?.brandGroup
                : authParams?.compBrands
                ? authParams?.compBrands
                : null;

              screenDuration = {
                from: authParams?.start_date,
                to: authParams?.end_date,
              };
            }
            // console.log("topFiveBrandList", topFiveBrandList);

            // calculation for barnd setup
            if (
              (authParams?.screen_id === "000-000-500" &&
                authParams?.filterScreen) ||
              authParams?.screen_id === "000-000-557" ||
              authParams?.screen_id === "000-000-558" ||
              authParams?.filterScreen
            ) {
              // Don't Need to update brand in case of this conditions because it's already calculated before
            } else if (
              screenFetchResData?.brand_ids?.length > 0 ||
              screenFetchResData?.brand_groups?.length > 0
            ) {
              if (screenFetchResData?.comp_brand_list?.length > 0) {
                let selectedComBrand = getSelectedCompBrand(
                  stateContainer?.competitorBrands,
                  screenFetchResData?.brand_ids,
                  screenFetchResData?.comp_brand_list
                );
                screenBrand = selectedComBrand;
              } else {
                let selectedNormalBrand = getBrands(
                  stateContainer?.logicalBrands,
                  screenFetchResData?.brand_ids,
                  stateContainer?.singleBrands,
                  screenFetchResData?.brand_groups
                );
                screenBrand = selectedNormalBrand;
              }
            } else {
              stateContainer.screen_type = screenFetchResData?.screen_type;
              let quick_filter =
                stateContainer?.graphConditionConfig &&
                stateContainer?.graphConditionConfig?.single_brand_select?.includes(
                  screenFetchResData?.screen_id
                )
                  ? true
                  : screenFetchResData?.quick_filter;
              let screenBrandsObj = getGlobalScreenBrandsValue(
                authParams?.filterScreen ? authParams : null,
                stateContainer,
                screenFetchResData?.screen_id,
                quick_filter
              );
              screenBrand = screenBrandsObj;
            }

            screenObject.includedWidgetList = includedWidgetList;
            let selectedScreenBrand = screenBrand
              ? screenBrand?.columns
                ? screenBrand
                : {
                    columns: screenBrand,
                    attribute: "BrandID",
                    type: "varchar",
                  }
              : authParams?.screen_id === "000-000-557"
              ? topFiveBrandList
              : defaultSingleBrand?.columns
              ? defaultSingleBrand
              : {
                  columns: defaultSingleBrand,
                  attribute: "BrandID",
                  type: "varchar",
                };
            screenObject.global_dashboard_brands = selectedScreenBrand;
            let selectedScreenDuration = screenDuration
              ? screenDuration
              : defaultDuration;
            screenObject.global_dashboard_duration = selectedScreenDuration;

            let logicalBrandExsit = [];
            if (stateContainer?.logicalBrands?.length) {
              logicalBrandExsit = stateContainer?.logicalBrands?.filter(
                (d) => d?.brand_group_name === authParams?.logical_brand_group
              );
            }
            if (
              !["000-000-500", "000-000-556", "000-000-557", "000-000-558"]?.includes(
                authParams?.screen_id
              ) &&
              authParams?.logical_brand_group &&
              logicalBrandExsit?.length
            ) {
              let obj = {
                attribute: "BrandID",
                columns: logicalBrandExsit,
                type: "varchar",
              };
              dispatch(setBrandsInScreen(obj));
            } else {
              dispatch(setBrandsInScreen(selectedScreenBrand));
            }
            // dispatch(setBrandsInScreen(selectedScreenBrand));
            dispatch(setDurationInScreen(selectedScreenDuration));

            if (authParams?.filters?.length > 0) {
              screenFilter = authParams?.filters;
            }
            // if (authParams?.screen_id === "000-000-553") {
            //   screenFilter = screenFetchResData?.widgets?.[0]?.filters;
            // }
            if (screenFilter?.length > 0) {
              dispatch(setGlobalFiltersInScreen(screenFilter));
            }

            screenFetchResData.isBrandModified =
              screenObject.global_dashboard_brands ? true : false;
            // If quick_filter exists in screen then call search-quick-filter api
            if (screenFetchResData?.quick_filter) {
              dispatch(setOpenCampaignPopup(true));
              let updatedScreenFetchResData = Object.keys(screenFetchResData)
                ?.length
                ? deepCopy(screenFetchResData)
                : { ...screenFetchResData };
              let screenData =
                JSON.parse(
                  window.localStorage.getItem(`screen_${authParams?.screen_id}`)
                ) || [];
              if (Object.keys(screenData)?.length) {
                updatedScreenFetchResData?.widgets?.forEach(
                  (widget, widgetIndex) => {
                    widget.filters =
                      screenData?.widgets?.[widgetIndex]?.filters;
                    return widget;
                  }
                );
                if (screenData?.filters?.length) {
                  updatedScreenFetchResData.filters = screenData?.filters;
                }
              } else {
                window.localStorage.setItem(
                  `screen_${authParams?.screen_id}`,
                  JSON.stringify(updatedScreenFetchResData)
                );
              }
              dispatch(
                setScreenProfileList(
                  authParams,
                  updatedScreenFetchResData,
                  screenObject
                )
              );
              // to add data key in graphdata if not available in dummy data case
              if (
                window.location.pathname.toLowerCase() ===
                "/commandcenter/screens/personalize"
              ) {
                updatedScreenFetchResData?.widgets?.forEach((widget, index) => {
                  if (
                    "graphData" in widget &&
                    updatedScreenFetchResData.widgets[index]["graphData"] &&
                    "data" in
                      updatedScreenFetchResData.widgets[index]["graphData"] ==
                      false
                  ) {
                    updatedScreenFetchResData.widgets[index]["graphData"] = {
                      data: widget["graphData"],
                    };
                  }
                });
              }
            } else {
              // remove other widget which is not required in this screen

              if (
                screenFetchResData?.widgets?.length > 0 &&
                Array.isArray(screenFetchResData?.widgets)
              ) {
                let updatedScreenWidgets = [];
                if (authParams?.screen_id === "000-000-557") {
                  let stream_screen_widgets = JSON.parse(
                    window?.localStorage.getItem("stream_screen_widgets") ||
                      "[]"
                  );

                  if (stream_screen_widgets?.length) {
                    updatedScreenWidgets = stream_screen_widgets?.map((d) => {
                      let updatedOrderBy = {
                        ...d?.order_by,
                        offset: 0,
                      };
                      if (d?.order_by) {
                        d.order_by = updatedOrderBy;
                        d.oldGraphData = null;
                        d.persist_graphdata = null;
                        d.graphData = null;
                      }
                      return d;
                    });

                    // Set default widget in screen
                    let defaultWidget = updatedScreenWidgets?.[0];
                    dispatch(setStreamScreenDefaultWidget(defaultWidget));
                  } else {
                    let widgetMetadata = screenFetchResData?.widgets?.[0];
                    topFiveBrandList?.map((d) => {
                      // console.log("widgetMetadata", widgetMetadata, "d data", d);
                      let el = {
                        ...widgetMetadata,
                        brand_ids: [d],
                        is_locked: true,
                        column_widget_id: uuid(),
                      };
                      updatedScreenWidgets?.push({ ...el });
                    });
                    // console.log("updatedScreenWidgets", updatedScreenWidgets);

                    // If no widgets list is there
                    // Store widgets list in local storage
                    window?.localStorage?.setItem(
                      "stream_screen_widgets",
                      JSON.stringify(updatedScreenWidgets)
                    );

                    // Set default widget in screen
                    let defaultWidget = screenFetchResData?.widgets?.[0];
                    dispatch(setStreamScreenDefaultWidget(defaultWidget));
                  }
                } else if (authParams?.screen_id === "000-000-558") {
                  let userBrands = {
                    brands: stateContainer?.singleBrands
                      ? stateContainer?.singleBrands
                      : stateContainer?.brands,
                    brandlogicalgroup: stateContainer?.logicalBrands
                      ? stateContainer?.logicalBrands
                      : stateContainer?.brandlogicalgroup,
                    competitorBrands: stateContainer?.competitorBrands,
                  };
                  let objForTemporyWordFunctionality = {
                    template_id: screenFetchResData?.screen_id,
                    temporary_words: stateContainer?.temporary_words
                      ? stateContainer?.temporary_words
                      : null,
                  };
                  let updatedScreenWidgetList =
                    getUpdatedScreenWidgetListBasedOnCompetitorCheck(
                      { ...screenFetchResData },
                      null,
                      true,
                      userBrands,
                      objForTemporyWordFunctionality
                    );
                  updatedScreenWidgets =
                    updatedScreenWidgetList?.length > 0
                      ? [...updatedScreenWidgetList]
                      : [];
                  let defaultSettings = {
                    is_competitor: false,
                    is_share_of_voice: false,
                    color_style: "1",
                    number_of_words: 50,
                    font_family: "",
                  };

                  screenFetchResData.settings = !screenFetchResData?.settings
                    ? {
                        ...defaultSettings,
                        is_competitor: true,
                      }
                    : {
                        ...screenFetchResData?.settings,
                        is_competitor: true,
                      };
                } else {
                  screenFetchResData?.widgets?.forEach((el) => {
                    if (includedWidgetList?.includes(el?.widget_id)) {
                      updatedScreenWidgets?.push({ ...el });
                    }
                  });
                }
                // setting local storage filters in widgets
                if (
                  screensWithPersistedFilters.includes(authParams?.screen_id) &&
                  !body?.is_preview
                ) {
                  let screenData =
                    JSON.parse(
                      window.localStorage.getItem(
                        `screen_${authParams?.screen_id}`
                      )
                    ) || [];
                  if (Object.keys(screenData)?.length) {
                    screenData?.widgets?.forEach((widget, widget_index) => {
                      if (updatedScreenWidgets?.length) {
                        updatedScreenWidgets[widget_index].filters =
                          screenData?.widgets?.[widget_index].filters;
                      } else {
                        screenFetchResData.widgets[widget_index].filters =
                          screenData?.widgets?.[widget_index].filters;
                      }
                      return widget;
                    });
                    // setting global filters from local storage
                    if (screenData?.filters?.length) {
                      screenFetchResData.filters = screenData?.filters;
                    }
                    screenFetchResData = {
                      ...screenFetchResData,
                      widgets:
                        updatedScreenWidgets?.length > 0
                          ? updatedScreenWidgets
                          : screenFetchResData?.widgets,
                    };
                  } else {
                    screenFetchResData = {
                      ...screenFetchResData,
                      widgets:
                        updatedScreenWidgets?.length > 0
                          ? updatedScreenWidgets
                          : screenFetchResData?.widgets,
                    };
                    window.localStorage.setItem(
                      `screen_${authParams?.screen_id}`,
                      JSON.stringify(screenFetchResData)
                    );
                  }
                } else {
                  screenFetchResData = {
                    ...screenFetchResData,
                    widgets:
                      updatedScreenWidgets?.length > 0
                        ? updatedScreenWidgets
                        : screenFetchResData?.widgets,
                  };
                }
              }
              // to add data key in graphdata if not available in dummy data case
              if (
                window.location.pathname.toLowerCase() ===
                "/commandcenter/screens/personalize"
              ) {
                if (authParams?.screen_id === "000-000-558") {
                  screenFetchResData?.widgets?.forEach((widget, index) => {
                    if (widget?.widget_name?.includes("TagCloud")) {
                      widget.graphData = dummyWidgetGraphData;
                    }
                  });
                } else if (authParams?.screen_id === "000-000-557") {
                  screenFetchResData?.widgets?.forEach((widget, index) => {
                    widget.graphData = dummyWidgetGraphData;
                  });
                }
                screenFetchResData.widgets.forEach((widget, index) => {
                  if (
                    "graphData" in widget &&
                    screenFetchResData.widgets[index]["graphData"] &&
                    "data" in screenFetchResData.widgets[index]["graphData"] ==
                      false
                  ) {
                    screenFetchResData.widgets[index]["graphData"] = {
                      data: widget["graphData"],
                    };
                  }
                });
              }
              dispatch(setScreenUpdatedData(screenFetchResData));
              // document.documentElement.style.setProperty(
              //   "--cc-screenContainer-color",
              //   response.paletteList[0]?.PrimaryTextColor
              // );
              // if (!body?.is_preview) {
              //   applyThemeWithVariable(response?.data?.result?.theme);
              //   dispatch(setSelectedThemeState(response?.data?.result?.theme));
              //   dispatch(setThemeId(response?.data?.result?.theme?.theme_id));
              // } else {
              //   dispatch(setSelectedThemeState(selectedThemeId));
              // }
            }
            //making it availabe for campaign screen(which has quick_filter) and others
            if (!body?.is_preview) {
              applyThemeWithVariable(response?.data?.result?.theme);
              dispatch(setSelectedThemeState(response?.data?.result?.theme));
              dispatch(setThemeId(response?.data?.result?.theme?.theme_id));
            } else {
              dispatch(setSelectedThemeState(selectedThemeId));
            }
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch);
          }
        }
      })
      .catch((error) => {
        dispatch(setScreenLoader(false));
        handleAxiosError(error, dispatch);
      });
  };
};

//api call to set chart data
export const setScreenWidgetGraphData = (
  authParams,
  graphObject,
  widget,
  quick,
  hidden_filter
) => {
  let quickFilter = quick !== undefined && quick ? quick : [];
  let errorMessage;
  let series_filter_check;
  Array.isArray(graphObject?.y_series) &&
    graphObject?.y_series?.forEach((el) => {
      if (el?.filters === null && !widget && !graphObject?.edit) {
        series_filter_check = graphObject?.predefined ? false : true;
      }
    });

  return async (dispatch) => {
    if (authParams && !series_filter_check) {
      let brands = graphObject?.brands?.columns
        ? graphObject?.brands?.columns
        : graphObject?.brands;
      let brand_obj = getFormattedBrandsForApi(
        graphObject?.isBrandModified,
        brands
      );
      // modifying x-axis date_aggregation
      let updatedXais = graphObject.x_axis
        ? deepCopy(graphObject.x_axis)
        : graphObject.x_axis;
      if (updatedXais?.date_aggregation) {
        updatedXais.date_part = updatedXais.date_aggregation;
      }
      // modifying y-axes date_aggregation
      let updatedYaxes =
        graphObject?.y_axes?.length > 0 ? deepCopy(graphObject?.y_axes) : null;
      if (
        updatedYaxes &&
        updatedYaxes?.length &&
        updatedYaxes?.some((y_axis) => y_axis?.date_aggregation)
      ) {
        updatedYaxes?.forEach((y_axis) => {
          if (y_axis?.date_aggregation) {
            y_axis.date_part = y_axis?.date_aggregation;
          }
        });
      }

      // Adding widget id in the array of screen
      if (widget) {
        let widgetIdForList = getWidgetIdForScreenApiCalledList(widget);
        dispatch(updateScreenApiCalledList(widgetIdForList, "ADD"));
        setTimeout(() => {
          dispatch(setGraphLoader(false));
        }, 1000);
      }

      // screen widget graphData clear
      if (widget) {
        dispatch(
          setClearScreenWidgetGraphData(
            widget?.section_index,
            widget?.widget_index,
            null,
            null,
            graphObject?.isRefreshEvent
          )
        );
      }
      //screen widget graph data clear end

      //high chart option data clear start
      let updateOpData = clearHighChartopData(widget, graphObject?.widget_id);
      dispatch(setOptionHighChart(updateOpData));
      //high chart option data clear end

      let pathName = getWindowLocationPath();
      let template_type = widget?.screen?.template_type;

      let body = graphObject?.payload
        ? {
            ...graphObject?.payload,
            exclude_words: graphObject?.exclude_words,
            utcoffset: getUTCOffset(),
          }
        : {
            ptoken: authParams?.ptoken,
            x_label: graphObject?.x_label, //by default attribute name
            y_label: graphObject?.y_label, // by default mention count
            filters: graphObject?.filters?.length
              ? [...graphObject?.filters]
              : graphObject?.filters,
            hidden_filter: hidden_filter,
            x_axis: updatedXais,
            y_axes: updatedYaxes,
            y_series: graphObject?.y_series,
            brand_groups:
              brand_obj?.brandsGroupName?.length > 0
                ? brand_obj?.brandsGroupName
                : null,
            comp_brand_list:
              brands && brands?.[0]?.competitor
                ? brands?.[0]?.competitorList
                : null,
            brand_list:
              brand_obj?.single_brands &&
              brand_obj?.single_brands?.[0]?.brand_id
                ? brand_obj?.single_brands
                : null,
            start_date: graphObject?.start_date,
            end_date: graphObject?.end_date,
            widget_name: graphObject?.widget_name,
            chart: graphObject?.chart,
            order_by: graphObject?.order_by,
            utcoffset: getUTCOffset(),
            filter_by_data: graphObject?.filter_by_data,
            filter_by: graphObject?.filter_by,
            widget_id: graphObject?.widget_id,
            engine: graphObject?.engine,
            exclude_words:
              graphObject?.exclude_words?.length > 0
                ? graphObject?.exclude_words
                : null,
            theme_type: authParams?.theme_type, //Dark Theme Type for 1 and Light Theme Type 0
            template_type: template_type,
            multilevel_breakdown: graphObject?.multilevel_breakdown
              ? graphObject?.multilevel_breakdown
              : null,
          };
      // Adding new keys to payload for network graph
      body.chart.chart_settings.chart_property.screen_width =
        window?.innerWidth;
      body.chart.chart_settings.chart_property.screen_height =
        window?.innerHeight;

      if (graphObject?.isNetworkChartV2) {
        body.widget_id = "NG-4";
      }

      let url = graphObject?.isUpdateImpression
        ? `${Config.config1.api_link}/command-center/chart?ignore_cache=True`
        : `${Config.config1.api_link}/command-center/chart`;

      await axios

        .post(url, body)
        .then((response) => {
          if (authParams?.screen_id === "000-000-561") {
            global.isPostGallaryData = false; // used for to reduced multiple api call in case of less posts
          }
          if (response?.data?.status === "successful") {
            // Disabled Date Aggregation Loader
            dispatch(setDateAggregationLoader(false));

            //import widget in dashboard
            widget &&
              dispatch(
                setScreenWidgetResponseGraphData(
                  response?.data?.result,
                  widget?.section_index >= 0 ? widget?.section_index : null,
                  widget?.widget_index,
                  body,
                  graphObject
                )
              );
            // delete excecuted api from list
            if (widget) {
              let widgetIdForList = getWidgetIdForScreenApiCalledList(widget);
              dispatch(updateScreenApiCalledList(widgetIdForList, "REMOVE"));
            }
          }
          if (response?.data?.status === "error") {
            widget &&
              dispatch(
                setScreenWidgetResponseGraphData(
                  response?.data?.error_code === 4
                    ? "No data found"
                    : response?.data?.reason,
                  widget?.section_index >= 0 ? widget?.section_index : null,
                  widget?.widget_index,
                  body,
                  graphObject
                )
              );
            dispatch(setErrorCode(response?.data?.error_code));

            // Custom error handlers for setScreenWidgetGraphData with specific business logic
            const customErrorHandlers = {
              9: (errorCodeValue, errorMessage, response, dispatch) => {
                // Session expired - special handling for screen widget graph data
                sessionExpired(true);
              },
              default: (errorCodeValue, errorMessage, response, dispatch) => {
                // Default error handling for other error codes including 21
                // Note: We don't call notification here as this is for screen widget graph data
              },
            };

            handleApiError(response, dispatch, { customErrorHandlers });
            //dispatch(setChartLoader(false));
            // delete excecuted api from list
            if (widget) {
              let widgetIdForList = getWidgetIdForScreenApiCalledList(widget);
              dispatch(updateScreenApiCalledList(widgetIdForList, "REMOVE"));
            }
          }
        })
        .catch((error) => {
          if (authParams?.screen_id === "000-000-561") {
            global.isPostGallaryData = false; // used for to reduced multiple api call in case of less posts
          }
          //delete excecuted api from list
          if (widget) {
            let widgetIdForList = getWidgetIdForScreenApiCalledList(widget);
            dispatch(updateScreenApiCalledList(widgetIdForList, "REMOVE"));
          }
          // Request aborted
          if (error.message !== "Request aborted") {
            // delete excecuted api from list
            if (widget) {
              let widgetIdForList = getWidgetIdForScreenApiCalledList(widget);
              dispatch(updateScreenApiCalledList(widgetIdForList, "REMOVE"));
            }

            // Use handleAxiosError for screen widget graph data catch
            const customErrorHandlers = {
              default: (errorCodeValue, errorMessage, response, dispatch) => {
                // No notification for screen widget graph data network errors
              },
            };

            handleAxiosError(error, dispatch, { customErrorHandlers });
          }
        });
    } else {
      //dispatch({ type: "SET_WIDGET_MAKER_CHART", payload: null });
    }
  };
};

// Deep Dive API Call
export const getScreenDeepDiveData = (deepdiveObj, body, widget_id) => {
  const { panes, tabName, paneIndex, shareBrands, shareTemplateData, screen } =
    deepdiveObj;
  return async (dispatch) => {
    dispatch(setDeepDiveLoader(true));
    widget_id === "1.1" && dispatch(setMentionPageInnerTabs(true));
    widget_id === "1.2" && dispatch(setMentionTabsNews(true));

    let url =
      deepdiveObj?.markInfluencerFlag || screen?.markInfluencersFlag
        ? `${Config.config1.api_link}/graph/${
            deepdiveObj?.shareBrands
              ? "share-deep-dive?ignore_cache=True"
              : "deep-dive?ignore_cache=True"
          }`
        : `${Config.config1.api_link}/graph/${
            deepdiveObj?.shareBrands ? "share-deep-dive" : "deep-dive"
          }`;
    await axios
      .post(url, { ...body, utcoffset: getUTCOffset() })
      .then((data) => {
        dispatch(setDeepDiveLoader(false));
        if (tabName === "TwitterTrends" || tabName === "GoogleTrends") {
          let widgetData;
          if (data?.data?.status === "successful") {
            widgetData = data?.data?.result;
          } else if (data?.data?.status === "error") {
            widgetData =
              data?.data?.error_code === 4 || data?.data?.error_code === 2
                ? "No data found"
                : data?.data?.reason;
          }

          dispatch(
            setScreenDeepDiveData(
              widgetData,
              screen,
              widget_id,
              tabName,
              shareBrands,
              shareTemplateData
            )
          );
          dispatch(setDeepDiveInfoLoader(false));
          dispatch(setMentionPageInnerTabs(false));
        } else if (widget_id === "info-bar") {
          dispatch(
            setScreenDeepDiveData(
              data?.data,
              screen,
              widget_id,
              null,
              shareBrands,
              shareTemplateData
            )
          );
          dispatch(setDeepDiveInfoLoader(false));
        } else if (widget_id === "1.1") {
          let obj = {};
          if (data?.data?.status === "error") {
            obj = {
              data: data?.data?.reason,
              page: 1,
              limit: 10,
              no_of_pages: 1,
            };
          } else {
            obj = {
              data: data?.data?.result?.data?.slice(0, 12),
              page: 1,
              limit: 12,
              no_of_pages: data?.data?.result?.no_of_pages,
              no_of_cards: data?.data?.result?.no_of_cards,
            };
          }
          dispatch(
            setScreenDeepDiveData(
              data?.data,
              screen,
              widget_id,
              tabName,
              shareBrands,
              shareTemplateData
            )
          );

          dispatch(setMentionPageData(obj));
          dispatch(setDeepDiveInfoLoader(false));
          dispatch(setMentionPageInnerTabs(false));
        } else if (widget_id === "1.2") {
          dispatch(
            setScreenDeepDiveData(
              data?.data,
              screen,
              widget_id,
              tabName,
              shareBrands,
              shareTemplateData
            )
          );
          dispatch(setDeepDiveInfoLoader(false));
          dispatch(setMentionTabsNews(false));
        } else {
          dispatch(
            setScreenDeepDiveData(
              data?.data,
              screen,
              widget_id,
              tabName,
              shareBrands,
              shareTemplateData
            )
          );
          dispatch(setDeepDiveInfoLoader(false));
          dispatch(setMentionPageInnerTabs(false));
        }
      })
      .catch((error) => {
        dispatch(setDeepDiveLoader(false));
        handleAxiosError(error, dispatch);
      });
  };
};
export const setCommandCenterWidgetFetch = (
  authParams,
  paneobject,
  propName,
  isNeedToUpdateAllWidgetWithSameId
) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ptoken: authParams?.ptoken,
      user_id: authParams?.userid,
      section_id: paneobject?.section_id,
      widget_id: paneobject?.widget_id,
      widget_uuid: paneobject?.widget_uuid,
      template_id: paneobject?.template_id,
      utcoffset: getUTCOffset(),
    };
    let url = `${Config.config1.api_link}/template/section/widget/fetch`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          let updatedMetaData = response?.data?.result;
          let temp_exclude_words = getTemporaryWords(paneobject);
          if (propName) {
            let updatedPropObj =
              propName === "exclude_words"
                ? [
                    {
                      prop_name: propName,
                      prop_value: updatedMetaData?.[propName]
                        ? updatedMetaData?.[propName]
                        : [],
                    },
                    {
                      prop_name: "temp_exclude_words",
                      prop_value: temp_exclude_words ? temp_exclude_words : [],
                    },
                    isNeedToUpdateAllWidgetWithSameId
                      ? {
                          prop_name: "comp_exclude_words",
                          prop_value: updatedMetaData?.["comp_exclude_words"]
                            ? updatedMetaData?.["comp_exclude_words"]
                            : null,
                        }
                      : {},
                  ]
                : isNeedToUpdateAllWidgetWithSameId
                ? [
                    {
                      prop_name: propName,
                      prop_value: updatedMetaData?.[propName],
                    },
                    {
                      prop_name: "comp_exclude_words",
                      prop_value: updatedMetaData?.["comp_exclude_words"]
                        ? updatedMetaData?.["comp_exclude_words"]
                        : null,
                    },
                  ]
                : {
                    prop_name: propName,
                    prop_value: updatedMetaData?.[propName],
                  };
            dispatch(
              updateScreenWidgetPropdataWithClearGraphData(
                paneobject?.section_index >= 0
                  ? paneobject?.section_index
                  : null,
                paneobject?.widget_index,
                updatedPropObj,
                isNeedToUpdateAllWidgetWithSameId ? paneobject?.widget_id : null
              )
            );
          } else {
            updatedMetaData.temp_exclude_words = temp_exclude_words;

            paneobject &&
              dispatch(
                setScreenWidgetMetaData(
                  updatedMetaData,
                  paneobject?.section_index >= 0
                    ? paneobject?.section_index
                    : null,
                  paneobject?.widget_index,
                  paneobject?.section_id //section id for only widgets
                )
              );
          }

          //dispatch(setWidgetUpdateFilterLoader(false));
        }
        if (response?.data?.status === "error") {
          //dispatch(setGraphLoader(false));
          //dispatch(setWidgetUpdateFilterLoader(false));

          let metadata = { ...paneobject?.widget_metadata };
          metadata.graphData = null;
          paneobject &&
            dispatch(
              setScreenWidgetMetaData(
                metadata,
                paneobject?.section_index >= 0
                  ? paneobject?.section_index
                  : null,
                paneobject?.widget_index,
                paneobject?.section_id //section id for only widgets
              )
            );
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        // dispatch(setGraphLoader(false));
        // dispatch(setWidgetUpdateFilterLoader(false));
        handleAxiosError(error, dispatch);
      });
  };
};
export const setCommandCenterWordcloudModifyWords = (
  authParams,
  paneobject,
  modalCheckboxValue = false,
  type
) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ptoken: authParams?.ptoken,
      template_id:
        paneobject?.brand_id || paneobject?.brand_group
          ? null
          : paneobject?.template_id,
      widget_id:
        paneobject?.brand_id || paneobject?.brand_group
          ? null
          : paneobject?.widget_id,
      widget_uuid: paneobject?.widget_uuid,
      section_id:
        paneobject?.brand_id || paneobject?.brand_group
          ? null
          : paneobject?.section_id,
      exclude_words: paneobject?.comp_exclude_words?.length
        ? undefined
        : paneobject?.exclude_words,
      include_words: paneobject?.comp_include_words?.length
        ? []
        : paneobject?.include_words
        ? paneobject?.include_words
        : [],
      comp_exclude_words: paneobject?.comp_exclude_words,
      comp_include_words: paneobject?.comp_include_words,
      brand_list: paneobject?.brand_id,
      brand_group: paneobject?.brand_group,
      wc_hide_temporary: paneobject?.wc_hide_temporary,
      wc_hide_permanent: paneobject?.wc_hide_permanent,
      wc_hide_brand: paneobject?.wc_hide_brand,
      utcoffset: getUTCOffset(),
    };
    dispatch(setGraphLoader(true));
    // dispatch(
    //   setWidgetLoader({
    //     value: true,
    //     widget_index: paneobject?.widget_index,
    //     section_index: paneobject?.section_index,
    //     widget_id: paneobject?.widget_id,
    //     global: false,
    //   })
    // );
    let url = `${Config.config1.api_link}/template/section/widget/modify-exclude-words`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          if (type !== "hidewordtemporarily") {
            dispatch(
              setCommandCenterWidgetFetch(
                authParams,
                paneobject,
                "exclude_words",
                paneobject?.comp_exclude_words?.length ||
                  paneobject?.comp_include_words?.length
              )
            );
          }
          if (type == "hidewordonbrandlevel") {
            dispatch(getBrandHiddenWords(authParams));
          }
          if (modalCheckboxValue) {
            dispatch(
              setBrandValue(authParams, null, null, null, modalCheckboxValue)
            );
          }
          // dispatch(setWidgetUpdateFilterLoader(true));
          // dispatch({
          //   type: "SET_WORDCLOUD_MODIFY_WORDS",
          //   panes: response?.data,
          // });
        }
        if (response?.data?.status === "error") {
          //dispatch(setGraphLoader(false));
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        //dispatch(setGraphLoader(false));
        handleAxiosError(error, dispatch);
      });
  };
};

// Delete Post From Tool
export const deletePostFromTool = (obj, men_obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      BrandInfo: {
        brandFriendlyName: obj?.brandFriendlyName,
        brandID: obj?.brandID,
        brandName: obj?.brandName,
      },
      DeleteParameter: {
        ChannelType: obj?.ChannelType,
        ContentId: obj?.ContentId,
        TagId: obj?.TagId,
      },
      // utcoffset: getUTCOffset(),
    };

    let angular_token = window.localStorage.getItem("ng_token");

    let url = `${Config.config1.angular_api_link}/Mention/DeleteFromLocobuzz`;
    axios
      .post(url, body, {
        headers: {
          Authorization: `Bearer ${angular_token}`,
        },
      })
      .then((response) => {
        let timer = null;
        if (response?.data?.success) {
          callNotification("Deleted successfully from locobuzz", "success");

          if (obj?.deepDive) {
            timer = setTimeout(() => {
              if (men_obj?.selectedTabName === "mentions") {
                let widget_ids2 = ["4.1"];
                delete men_obj.influencers_object.deepdive_on.order_by;
                delete men_obj.influencers_object.filter_by_data;
                men_obj.influencers_object.filter_by = null;
                let mentions_obj1 = {
                  ...men_obj?.influencers_object,
                  tabName: "Influencers",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };
                dispatch(
                  getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids2)
                );

                let widget_ids1 = ["info-bar"];
                let info_bar_object = {
                  ...men_obj?.infoBarObject,
                  tabName: "info-bar",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };
                dispatch(
                  getDeepDive(men_obj?.authParams, info_bar_object, widget_ids1)
                );

                let widget_ids = ["1.1"];
                let mentions_obj = {
                  ...men_obj?.mentions_object,
                  tabName: "Mentions",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };
                dispatch(
                  getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
                );
              } else if (men_obj?.selectedTabName === "influencers") {
                let widget_ids2 = ["1.1"];
                let mentions_obj1 = {
                  ...men_obj?.mentions_object,
                  tabName: "Mentions",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };
                dispatch(
                  getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids2)
                );

                // Info bar api call
                let widget_ids1 = ["info-bar"];
                let info_bar_object = {
                  ...men_obj?.infoBarObject,
                  tabName: "info-bar",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };
                dispatch(
                  getDeepDive(men_obj?.authParams, info_bar_object, widget_ids1)
                );

                let widget_ids = ["4.1"];
                let mentions_obj = {
                  ...men_obj?.influencers_object,
                  tabName: "Influencers",
                  screen: men_obj?.screen,
                  markInfluencerFlag: men_obj?.markInfluencerFlag,
                };

                dispatch(
                  getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
                );
              }

              if (
                men_obj?.deepdive_object?.deepdive_on?.y_series?.attribute ===
                "tagid"
              ) {
                let arrr = {
                  ...men_obj?.deepdive_object,
                  deepdive_on: {
                    ...men_obj?.deepdive_object.deepdive_on,
                    y_series: {
                      ...men_obj?.deepdive_object?.deepdive_on?.y_series,
                      value:
                        men_obj?.deepdive_object?.deepdive_on?.y_series?.value -
                        1,
                    },
                  },
                };
                dispatch(setDeepDiveObject(arrr));
              }
            }, 1000);
          }
        } else {
          handleApiError(response, dispatch);
        }

        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

// Get Mark Influencers List
export const getInfluencersList = (obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      brandFriendlyName: obj?.brandFriendlyName,
      brandID: obj?.brandID,
      brandName: obj?.brandName,
      // utcoffset: getUTCOffset(),
    };

    let angular_token = window.localStorage.getItem("ng_token");

    let url = `${Config.config1.angular_api_link}/Tickets/GetBrandInfluencer`;
    axios
      .post(url, body, {
        headers: {
          Authorization: `Bearer ${angular_token}`,
        },
      })
      .then((response) => {
        if (response?.data?.success) {
          dispatch(setMarkInfluencersList(response?.data?.data));
        } else {
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

// Insert Mark Influencers Post
export const InsertMarkInfluencerPost = (obj, men_obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      AuthorSocialID:
        obj?.AuthorName === "Anonymous" &&
        obj?.AuthorSocialID === obj?.AuthorSocialID
          ? 0
          : obj?.AuthorSocialID,
      BrandID: obj?.BrandID,
      BrandName: obj?.BrandName,
      ChannelType: obj?.ChannelType,
      InfluencerCategoryID: obj?.InfluencerCategoryID,
      InfluencerCategoryName: obj?.InfluencerCategoryName,
      ScreenName: obj?.ScreenName,
      InfluencerCategories: obj?.InfluencerCategories,
      InfluencerCategoryID: obj?.InfluencerCategoryID,
      InfluencerCategoryName: obj?.InfluencerCategoryName,
      // utcoffset: getUTCOffset(),
    };

    let angular_token = window.localStorage.getItem("ng_token");

    let url = `${Config.config1.angular_api_link}/Tickets/InsertUpdateInfluencer`;
    axios
      .post(url, body, {
        headers: {
          Authorization: `Bearer ${angular_token}`,
        },
      })
      .then((response) => {
        let timer = null;
        dispatch(setMarkInfluencersFlag(true));
        if (response?.data?.success) {
          // ${obj?.AuthorName} will be marked as Influencer in a minute's time
          callNotification(`Marked as Influencer successfully.`, "success");

          // Call API
          timer = setTimeout(() => {
            if (men_obj?.selectedTabName === "mentions") {
              let widget_ids1 = ["4.1"];
              delete men_obj.influencers_object.deepdive_on.order_by;
              delete men_obj.influencers_object.filter_by_data;
              men_obj.influencers_object.filter_by = null;
              let mentions_obj1 = {
                ...men_obj?.influencers_object,
                tabName: "Influencers",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };
              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids1)
              );

              let widget_ids = ["1.1"];
              let mentions_obj = {
                ...men_obj?.mentions_object,
                tabName: "Mentions",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };

              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
              );
            } else if (men_obj?.selectedTabName === "influencers") {
              let widget_ids1 = ["1.1"];
              let mentions_obj1 = {
                ...men_obj?.mentions_object,
                tabName: "Mentions",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };
              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids1)
              );

              let widget_ids = ["4.1"];
              let mentions_obj = {
                ...men_obj?.influencers_object,
                tabName: "Influencers",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };

              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
              );
            }
          }, 1000);
        } else {
          handleApiError(response, dispatch);
        }

        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

// Remove Mark Influencers Post
export const removeMarkInfluencerPost = (obj, men_obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      AuthorSocialID:
        obj?.AuthorName === "Anonymous" &&
        obj?.AuthorSocialID === obj?.AuthorSocialID
          ? 0
          : obj?.AuthorSocialID,
      BrandID: obj?.BrandID,
      BrandName: obj?.BrandName,
      ChannelType: obj?.ChannelType,
      InfluencerCategoryID: obj?.InfluencerCategoryID,
      InfluencerCategoryName: obj?.InfluencerCategoryName,
      IsInactive: obj?.IsInactive,
      ScreenName: obj?.ScreenName,
      InfluencerCategories: obj?.InfluencerCategories,
      InfluencerCategoryID: obj?.InfluencerCategoryID,
      InfluencerCategoryName: obj?.InfluencerCategoryName,
      // utcoffset: getUTCOffset(),
    };
    let angular_token = window.localStorage.getItem("ng_token");

    let url = `${Config.config1.angular_api_link}/Tickets/InActiveInfluencer`;
    axios
      .post(url, body, {
        headers: {
          Authorization: `Bearer ${angular_token}`,
        },
      })
      .then((response) => {
        let timer = null;
        dispatch(setMarkInfluencersFlag(true));
        if (response?.data?.success) {
          // ${obj?.AuthorName} will be removed as Influencer in a minute's time
          callNotification(`Influencer Removed successfully.`, "success");

          // Call API
          timer = setTimeout(() => {
            if (men_obj?.selectedTabName === "mentions") {
              let widget_ids1 = ["4.1"];
              delete men_obj.influencers_object.deepdive_on.order_by;
              delete men_obj.influencers_object.filter_by_data;
              men_obj.influencers_object.filter_by = null;
              let mentions_obj1 = {
                ...men_obj?.influencers_object,
                tabName: "Influencers",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };
              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids1)
              );

              let widget_ids = ["1.1"];
              let mentions_obj = {
                ...men_obj?.mentions_object,
                tabName: "Mentions",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };

              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
              );
            } else if (men_obj?.selectedTabName === "influencers") {
              let widget_ids1 = ["1.1"];
              let mentions_obj1 = {
                ...men_obj?.mentions_object,
                tabName: "Mentions",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };
              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj1, widget_ids1)
              );

              let widget_ids = ["4.1"];
              let mentions_obj = {
                ...men_obj?.influencers_object,
                tabName: "Influencers",
                screen: men_obj?.screen,
                markInfluencerFlag: men_obj?.markInfluencerFlag,
              };

              dispatch(
                getDeepDive(men_obj?.authParams, mentions_obj, widget_ids)
              );
            }
          }, 1000);
        } else {
          handleApiError(response, dispatch);
        }

        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

// Hide Post From Tool
export const hidePostFromTool = (obj) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ptoken: obj?.authParams?.ptoken,
      user_id: obj?.authParams?.userid,
      category_id: obj?.authParams?.category_id,
      category_name: obj?.authParams?.category_name,
      tagid: obj?.tagid,
      utcoffset: getUTCOffset(),
    };
    let url = `${Config.config1.api_link}/command-center/hide-mention`;
    axios
      .post(url, body)
      .then((response) => {
        if (response?.data?.status === "successful") {
          // console.log("hide-mention success", response?.data);
          callNotification(
            "Post hidden successfully from warroom screen",
            "success"
          );
        }
        if (response?.data?.status === "error") {
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      });
  };
};

// Hide Post From Tool
export const getListOfSearchedTopic = (obj) => {
  let errorMessage;
  return async (dispatch) => {
    dispatch(setSearchedTopicLoader(true));
    let body = {
      ptoken: obj?.authParams?.ptoken,
      user_id: obj?.authParams?.userid,
      category_id: obj?.authParams?.category_id,
      category_name: obj?.authParams?.category_name,
      country_code: obj?.country_code,
      state: obj?.state,
      city: obj?.city,
      attribute: obj?.attribute,
      search_string: obj?.search_string,
      start_date: obj?.start_date,
      end_date: obj?.end_date,
      utcoffset: getUTCOffset(),
    };
    let url = `${Config.config1.api_link}/command-center/search-topic`;
    axios
      .post(url, body)
      .then((response) => {
        dispatch(setSearchedTopicLoader(false));
        if (response?.data?.status === "successful") {
          dispatch(setSearchedTopicList(response?.data?.result));
        }
        if (response?.data?.status === "error") {
          dispatch(setSearchedTopicList(null));
          handleApiError(response, dispatch);
        }
      })
      .catch((error) => {
        dispatch(setSearchedTopicLoader(false));
        dispatch(setSearchedTopicList(null));
        handleAxiosError(error, dispatch);
      });
  };
};
